import * as THREE from 'three';
import { getOrigin } from '../config/siteConfig';
import { collarMine } from './holePath';
import { listCollarRecords } from '../store/holeRecordStore';
import { mineToScene, sceneToMine } from './sectionMath';

const GRID_STEP = 1;

function roundTo(n, step) {
  return Math.round(n / step) * step;
}

export function snapThreshold(camera, point) {
  if (!camera || !point) return 8;
  const dist = camera.position.distanceTo(point);
  return Math.min(25, Math.max(2.5, dist * 0.012));
}

/**
 * Snap a scene hit to a hole collar, then 1 m mine grid.
 */
export function snapScenePoint(point, { camera, enabled = true } = {}) {
  if (!enabled || !point) {
    return { point, kind: 'none', label: '', mine: sceneToMine(point.x, point.y, point.z) };
  }
  const origin = getOrigin();
  const mine = sceneToMine(point.x, point.y, point.z, origin);
  const maxDist = snapThreshold(camera, point);
  let best = null;
  let bestD = maxDist;
  listCollarRecords().forEach(({ holeId, rec }) => {
    const c = collarMine(rec.collar);
    if (!c) return;
    const scene = mineToScene(c.east, c.north, c.rl, origin);
    const d = scene.distanceTo(point);
    if (d < bestD) {
      bestD = d;
      best = { holeId, scene, mine: c };
    }
  });
  if (best) {
    return {
      point: best.scene.clone(),
      kind: 'collar',
      label: `collar ${best.holeId}`,
      mine: best.mine,
    };
  }
  const snappedMine = {
    east: roundTo(mine.east, GRID_STEP),
    north: roundTo(mine.north, GRID_STEP),
    rl: roundTo(mine.rl, GRID_STEP),
  };
  const grid = mineToScene(snappedMine.east, snappedMine.north, snappedMine.rl, origin);
  const gridD = grid.distanceTo(point);
  if (gridD <= maxDist * 0.6 && gridD > 0.02) {
    return {
      point: grid,
      kind: 'grid',
      label: '1 m grid',
      mine: snappedMine,
    };
  }
  return {
    point: point instanceof THREE.Vector3 ? point.clone() : new THREE.Vector3(point.x, point.y, point.z),
    kind: 'none',
    label: '',
    mine,
  };
}
